<template>
  <div id="app">
    <b-navbar
      v-if="
        path !== '/export' &&
        path !== '/login' &&
        path !== '/register' &&
        path !== '/forgot' &&
        path !== '/active'
      "
      type="is-light"
    >
      <template slot="brand">
        <b-navbar-item tag="router-link" :to="{ path: '/' }">
          <img
            src="@/assets/logo-full.png"
            alt="Lightweight UI components for Vue.js based on Bulma"
          />
        </b-navbar-item>
        <b-navbar-item
          tag="div"
          v-if="$device.mobile || $device.iphone || $device.ipad"
        >
          <div
            class="buttons has-text-centered"
            style="
              width: stretch;
              display: flex;
              justify-content: center;
              align-items: center;
            "
          >
            <a class="is-primary" href="/#/"> Trang chủ </a>
            <span class="mx-1">|</span>
            <a
              class="is-primary"
              href="https://www.facebook.com/coach.khanh.tran"
              target="_blank"
            >
              Fanpage
            </a>
            <span class="mx-1">|</span>
            <a
              class="is-primary"
              href="https://www.facebook.com/groups/nghe.nghiep.cua.con"
              target="_blank"
            >
              Group
            </a>
          </div>
        </b-navbar-item>
      </template>

      <template slot="end">
        <b-navbar-item tag="div">
          <div class="buttons">
            <a
              v-if="user && user.utype === 'admin' && path !== '/admin'"
              class="button is-primary"
              href="/#/admin"
            >
              Quản lý tài khoản
            </a>
            <a
              v-if="!user && path !== '/login'"
              class="button is-primary"
              href="/#/login"
            >
              Đăng nhập
            </a>
            <a v-if="user" class="button is-danger" href="#" @click="logout">
              Đăng xuất
            </a>
          </div>
        </b-navbar-item>
      </template>
    </b-navbar>
    <section class="app-content">
      <router-view />
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "App",
  computed: {
    ...mapGetters(["user"]),
    path() {
      return this.$route.path;
    },
  },
  methods: {
    logout() {
      this.$store.dispatch("logout").then(() => {
        if (this.$route.path != "/") {
          setTimeout(() => {
            this.$router.push("/");
          }, 1000);
        }
      });
    },
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;

  .app-content {
    width: 100%;
    min-height: 100vh;
    background-color: white;
  }
}
</style>
